import { useMemo } from 'react';

import { useAppInfo } from './useAppInfo/useAppInfo';
import { useLocation } from './useLocation';

export function useBackgroundImage(id: string = import.meta.env.VITE_APP_ID) {
  const location = useLocation();

  const { data: app } = useAppInfo(id);

  return useMemo(() => {
    const backgroundImage = app?.background_images?.find((image) => {
      return new RegExp(image.regex).test(location.pathname);
    });

    return backgroundImage?.image ?? app?.general_background_image;
  }, [app?.background_images]);
}
